import GoodsMain from "./goods/main";

const main = new GoodsMain();
